import { OrderQuery as OrderQuerySource } from 'SourceQuery/Order.query';
import { Field } from 'Util/Query';

export class OrderQuery extends OrderQuerySource {
    getOrderByIdCtrlQuery(orderId, ctrl) {
        return this._getOrderByIdCtrlField(orderId, ctrl);
    }

    _getOrderByIdCtrlField(orderId, ctrl) {
        return new Field('getOrderByIdCtrl')
            .addArgument('id', 'Int!', orderId)
            .addArgument('ctrl', 'String!', ctrl)
            .addFieldList(this._getOrderItemsFields());
    }
    _getBaseOrderInfoFields(isList) {
        return [
            'id',
            'increment_id',
            'created_at',
            'status_label',
            'grand_total',
            'total_discount_amount',
            ...(isList ? [] : ['sub_total']),
            'invoice_url',
            'payment_fee',
            'estimated_delivery_date',
            'base_rwp_amount',
            this._orderAdditionalAttributesField(),
            this._orderDiscountDataFields()
        ];
    }

    _orderAdditionalAttributesField() {
        return new Field('additional_attributes')
            .addFieldList(this._orderAdditionalAttributesFields());
    }

    _orderAdditionalAttributesFields() {
        return [
            'curier',
            'nr_awb',
            'link_awb',
            'comanda_platita',
            this._orderAdditionalAttributesInvoiceField()
        ]
    }

    _orderAdditionalAttributesInvoiceField() {
        return new Field('factura')
            .addFieldList(this._orderAdditionalAttributesInvoiceFields());
    }

    _orderAdditionalAttributesInvoiceFields() {
        return [
            'url',
            'id'
        ]
    }

    _orderDiscountDataFields() {
        return new Field('discount_data')
        .addFieldList(['label', 'amount']);
    }

    _getDefaultFields() {
        return [
            'id',
            'name',
            (new Field('short_description').addField('html')),
            'sku',
            'qty',
            'row_total',
            'original_price',
            'license_key',
            'free_gift_item',
            'url_key'
        ];
    }
}

export default new OrderQuery();
